import { ITEMS } from "./items"

export const CAVES_ID = {
    1001: 'inner',
    1002: 'inner2',
    1003: 'test_3_lvl',

    2: 'test2',

    21: 'island_test_1'

}

export const CAVES = {

    inner: {
        label: 'Учебная 1',
        discription: 'Эта пещера для новичков, чтобы научиться атаковать',
        id: 1001,
        innerLvl: 1,
        maxLvl: 1,

        tryes: 5,
        deathPenalty: 1,


        blockStructure: {
            1: {
                id: 1,
                enterFrom: null,
                x: 0,
                y: 0,
                enemys: [
                    { name: 'usualBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 3,
                expAll: 3,
            },
            2: {
                id: 2,
                enterFrom: 1,
                x: 1,
                y: 0,
                enemys: [
                    { name: 'usualBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 3,
                expAll: 3,
            },
            3: {
                id: 3,
                enterFrom: 2,
                x: 2,
                y: 0,
                endRound: true,
                enemys: [
                    { name: 'usualBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 4,
                expAll: 4,
            }
        },
        achivments: {

        }
    },

    island_test_1: {
        label: 'Учебная остров 1',
        discription: 'Эта пещера для тестов в острове',
        id: 21,
        innerLvl: 1,
        maxLvl: 100,

        tryes: 5,
        deathPenalty: 1,


        blockStructure: {
            1: {
                id: 1,
                enterFrom: null,
                x: 0,
                y: 0,
                enemys: [
                    { name: 'speeder', props: { lvl: 3 }, lut: [], percent: 100 }
                ],
                conditions: {
                    darkness: {
                        lvl: 3
                    },
                    cold: {
                        lvl: 3,
                        dpl: 0.1  
                    }
                },
                expOnce: 1,
                expAll: 3,
            },
            2: {
                id: 2,
                enterFrom: 1,
                x: 1,
                y: -0.6,
                enemys: [
                    { name: 'usualBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 1,
                expAll: 3,
            },
            3: {
                id: 3,
                enterFrom: 1,
                x: 1,
                y: 0.6,
                endRound: true,
                enemys: [
                    { name: 'usualBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 1,
                expAll: 3,
            },
            4: {
                id: 4,
                enterFrom: 2,
                x: 2,
                y: -0.6,
                endRound: true,
                enemys: [
                    { name: 'usualBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 1,
                expAll: 3,
            }
        },
        achivments: {

        }
    },

    inner2: {
        label: 'Учебная 1',
        discription: 'Эта пещера для новичков, чтобы научиться защищаться',
        id: 1002,
        innerLvl: 1,
        maxLvl: 1,

        tryes: 5,
        deathPenalty: 1,


        blockStructure: {
            1: {
                id: 1,
                enterFrom: null,
                x: 0,
                y: 0,
                enemys: [
                    { name: 'forceBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 3,
                expAll: 6,
            },
            2: {
                id: 2,
                enterFrom: 1,
                x: 1,
                y: 0,
                enemys: [
                    { name: 'forceBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 3,
                expAll: 6,
            },
            3: {
                id: 3,
                enterFrom: 2,
                x: 2,
                y: 0,
                endRound: true,
                enemys: [
                    { name: 'forceBag', props: {}, lut: [], percent: 100 }
                ],
                expOnce: 4,
                expAll: 8,
            }
        },
        achivments: {

        }
    },

    test_3_lvl: {
        label: 'Тренировочная',
        id: 1003,
        discription: 'Такая средняя пещера 3-го уровня',
        innerLvl: 3,
        maxLvl: 5,

        tryes: 7,
        deathPenalty: 1,

        blockStructure: {
            1: {
                id: 1,
                enterFrom: null,
                x: 0,
                y: 0,
                expOnce: 1,
                expAll: 3,
                enemys: [
                    {
                        name: 'bazed', props: { lvl: 2 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 20
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 20
                            },
                            {
                                name: 'sbiv_1_a',
                                countRandom: false,
                                isRare: true,
                                percent: 5
                            }
                        ]
                        , percent: 100
                    }
                ]
            },
            2: {
                id: 2,
                enterFrom: 1,
                x: 1,
                y: 0,
                expOnce: 2,
                expAll: 4,
                enemys: [
                    {
                        name: 'speeder', props: { lvl: 2 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 35
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 35
                            }
                        ]
                        , percent: 35
                    },
                    {
                        name: 'spices', props: { lvl: 2 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 35
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 35
                            }
                        ]
                        , percent: 50
                    },
                    {
                        name: 'spices', props: { lvl: 2 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 35
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 35
                            }
                        ]
                        , percent: 100
                    }
                ]
            },
            3: {
                id: 3,
                enterFrom: 2,
                x: 2,
                y: 0,
                expOnce: 2,
                expAll: 4,
                enemys: [
                    {
                        name: 'speeder', props: { lvl: 2 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 35
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 35
                            }
                        ]
                        , percent: 35
                    },
                    {
                        name: 'spices', props: { lvl: 2 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 35
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 35
                            }
                        ]
                        , percent: 50
                    },
                    {
                        name: 'spices', props: { lvl: 3 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 35
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 35
                            }
                        ]
                        , percent: 100
                    }
                ]
            },
            4: {
                id: 4,
                enterFrom: 3,
                x: 3,
                y: 0,
                endRound: true,
                expOnce: 2,
                expAll: 4,
                enemys: [
                    {
                        name: 'spices', props: { lvl: 3 },
                        lut: [
                            {
                                name: 'sbiv_1_a',
                                countRandom: false,
                                isRare: true,
                                percent: 15
                            }
                        ]
                        , percent: 50
                    },
                    {
                        name: 'speeder', props: { lvl: 3 },
                        lut: [
                            {
                                name: 'sbiv_1_a',
                                countRandom: false,
                                isRare: true,
                                percent: 15
                            }
                        ]
                        , percent: 100
                    }
                ]
            }
        },
        achivments: {

        }
    },

    inner4: {
        label: 'Тренировочная',
        id: 1,
        discription: 'Эта пещера для новичков, чтобы освоиться',
        innerLvl: 1,
        maxLvl: 2,

        tryes: 5,
        deathPenalty: 1,

        blockStructure: {
            1: {
                id: 1,
                enterFrom: null,
                x: 0,
                y: 0,
                expOnce: 3,
                expAll: 20,
                enemys: [
                    {
                        name: 'forceBag', props: { lvl: 1 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 70
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 70
                            },
                            {
                                name: 'sbiv_1_a',
                                countRandom: false,
                                isRare: true,
                                percent: 90
                            }
                        ]
                        , percent: 100
                    }
                ]
            },
            2: {
                id: 2,
                enterFrom: 1,
                x: 1,
                y: 0,
                expOnce: 3,
                expAll: 20,
                enemys: [
                    {
                        name: 'forceBag', props: { lvl: 1 },
                        lut: [
                            {
                                name: 'extra_strength_1_incave_a',
                                countRandom: false,
                                percent: 70
                            },
                            {
                                name: 'extra_sbiv_1_incave_a',
                                countRandom: false,
                                percent: 70
                            }
                        ]
                        , percent: 100
                    }
                ]
            },
            3: {
                id: 3,
                enterFrom: 2,
                x: 2,
                y: 0,
                endRound: true,
                expOnce: 10,
                expAll: 30,
                enemys: [
                    { name: 'forceBag', props: { lvl: 2 }, lut: [], percent: 100 }
                ]
            }
        },
        achivments: {

        }
    },

    test2: {
        label: 'Тестовая',
        id: 2,
        discription: 'А тут вот поиграем',
        innerLvl: 2,
        maxLvl: 5,

        tryes: 12,
        deathPenalty: 1,

        blockStructure: {
            1: {
                id: 1,
                enterFrom: null,
                x: 0,
                y: 0,
                expOnce: 1,
                expAll: 10,
                enemys: [
                    {
                        name: 'usualBag', props: { lvl: 2 }, lut: [
                            // {
                            //     name: 'sn1',
                            //     countRandom: false,
                            //     count: 10,
                            //     percent: 100
                            // },
                            // {
                            //     name: 'sn2',
                            //     countRandom: false,
                            //     count: 2,
                            //     isRare: true,
                            //     percent: 100
                            // },
                        ], percent: 100
                    }
                ]
            },
            2: {
                id: 2,
                enterFrom: null,
                x: 1,
                y: 0,
                expOnce: 1,
                expAll: 10,
                enemys: [
                    { name: 'usualBag', props: { lvl: 3 }, lut: [], percent: 100 }
                ]
            },
            3: {
                id: 3,
                enterFrom: null,
                x: 2,
                y: 0,
                expOnce: 1,
                expAll: 10,
                enemys: [
                    { name: 'usualBag', props: { lvl: 4 }, lut: [], percent: 100 }
                ]
            },
            4: {
                id: 4,
                enterFrom: null,
                endRound: true,
                x: 3,
                y: 0,
                expOnce: 1,
                expAll: 10,
                enemys: [
                    { name: 'usualBag', props: { lvl: 5 }, lut: [], percent: 100 }
                ]
            },
        },
        achivments: {

        }
    }

}